import { Check, X } from "lucide-react";
import { shootoutScore } from "@/lib/events";
import { teamStyle } from "@/lib/colors";

const running = (m) => {
  const t = { home: 0, away: 0 };
  return (m.shootout || []).map((k) => { if (k.scored) t[k.team] += 1; return `${t.home}-${t.away}`; });
};

export const shootoutRows = (m) => {
  const r = running(m);
  return m.shootout.map((k, i) => [i + 1, m[k.team].name, `Nº ${k.player}`, k.scored ? "Marcou" : "Falhou", r[i]]);
};

const winner = (m) => {
  const h = shootoutScore(m, "home"), a = shootoutScore(m, "away");
  return h === a ? null : m[h > a ? "home" : "away"].name;
};

export const ShootoutSummary = ({ match }) => {
  const r = running(match);
  const w = winner(match);
  return (
    <div data-testid="shootout-summary" className="border border-white/15 bg-[#131313] p-4 sm:p-6">
      <p data-testid="shootout-summary-result" className="font-display text-2xl font-bold uppercase mb-4">
        {shootoutScore(match, "home")}–{shootoutScore(match, "away")} g.p.{w && <span className="text-[#CCFF00]"> · Vence {w}</span>}
      </p>
      <ol className="divide-y divide-white/10 border-y border-white/10">
        {match.shootout.map((k, i) => (
          <li key={k.id} data-testid={`shootout-summary-kick-${i + 1}`} className="flex items-center gap-3 py-2 text-sm">
            <span className="w-6 text-zinc-500 tabular-nums">{i + 1}</span>
            <span style={teamStyle(match[k.team])} className="px-2 py-0.5 font-display font-bold uppercase truncate max-w-[40%]">{match[k.team].name}</span>
            <span className="font-semibold">Nº {k.player}</span>
            <span className={`flex items-center gap-1 ${k.scored ? "text-[#34C759]" : "text-[#FF3B30]"}`}>
              {k.scored ? <Check size={16} /> : <X size={16} />}{k.scored ? "Marcou" : "Falhou"}
            </span>
            <span className="ml-auto font-display font-bold tabular-nums">{r[i]}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};
